module.exports = __webpack_public_path__ + "img/arrow-b.cc256c9e.svg";